import { Link } from "react-router-dom";

export default function CTABlock({
  eyebrow = "Consultation",
  heading = "Need Clear Legal Direction?",
  body = "Whether your matter is at the advisory stage, notice stage, dispute stage or court stage, Lex Polaris can help you understand your legal position and plan the next step with clarity.",
  primaryLabel = "Book a Consultation",
  primaryTo = "/contact",
  secondaryLabel = "WhatsApp Us",
  secondaryHref = "https://wa.me/919810899124?text=Hello%20Lex%20Polaris%20Team%2C%20I%20would%20like%20to%20discuss%20a%20legal%20matter.",
  variant = "dark",
}) {
  const dark = variant === "dark";
  return (
    <section
      data-testid="cta-block"
      className={dark ? "bg-navy text-ivory" : "bg-ivory text-charcoal"}
    >
      <div className="container-px max-w-[1400px] mx-auto section-y">
        <div className="grid md:grid-cols-12 gap-10 items-end">
          <div className="md:col-span-7">
            <div className={`overline ${dark ? "text-gold" : "text-gold"} mb-5`}>{eyebrow}</div>
            <h2 className={`h-display text-4xl md:text-5xl lg:text-6xl ${dark ? "text-ivory" : "text-navy"}`}>
              {heading}
            </h2>
          </div>
          <div className="md:col-span-5">
            <p className={`body-lg ${dark ? "text-ivory/75" : "text-charcoal/75"} mb-8 max-w-md`}>
              {body}
            </p>
            <div className="flex flex-wrap gap-3">
              <Link
                to={primaryTo}
                data-testid="cta-block-primary"
                className={dark
                  ? "inline-flex items-center justify-center bg-gold text-deep-ink px-7 py-4 text-sm tracking-[0.16em] uppercase font-medium hover:bg-ivory hover:text-navy transition-colors duration-300"
                  : "btn-primary"}
              >
                {primaryLabel}
              </Link>
              <a
                href={secondaryHref}
                data-testid="cta-block-secondary"
                className={dark ? "btn-outline-light" : "btn-outline"}
              >
                {secondaryLabel}
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
